import { Suspense, lazy } from "react";
import { useLocation } from "react-router-dom";
import { useScrollToHash, useIsMobile } from "../Controller/HomePageController";
import SpinnerLoader from "../../../../assets/loader/SpinnerLoader";

const LandingScreenView = lazy(() => import('./../../../components/HomePage/LandingScreen/View/LandingScreenView'));
const MissionAndVisionView = lazy(() => import('./../../../components/HomePage/VisionsAndMissions/View/MissionAndVisionView'));
const DomainView = lazy(() => import('./../../../components/HomePage/Domains/View/DomainView'));
const SolutionAltView = lazy(() => import("../../../components/HomePage/Solutions_2/View/SolutionsAltView"));

const LandingScreenMobileView = lazy(() => import("../../../components/HomePage/LandingScreen/View/LandingScreenMobileView"));
const DomainMobileView = lazy(() => import("../../../components/HomePage/Domains/View/DomainMobileView"));
const SolutionsMobileView = lazy(() => import("../../../components/HomePage/Solutions/View/SolutionsMobileView"));
const MissionAndVisionMobileView = lazy(() => import("../../../components/HomePage/VisionsAndMissions/View/MissionAndVisionMobileView"));

const HomePageView = () => {
  const location = useLocation();
  useScrollToHash(location);
  const isMobile = useIsMobile();

  return (
    <>

      {isMobile ? (
        <>
          <Suspense fallback={<></>}>
            <LandingScreenMobileView />
          </Suspense>
          <div id="visionMission">
            <MissionAndVisionMobileView />
          </div>
          <div id="domains">
            <DomainMobileView />
          </div>
          <div id="solutions">
            <SolutionsMobileView />
          </div>
        </>
      ) : (
        <>
          <Suspense fallback={<div><></></div>}>
            <LandingScreenView />
          </Suspense>
          <div id="visionMission">
            <MissionAndVisionView />
          </div>
          <div id="domains">
            <DomainView />
          </div>
          <div id="solutions">
            <SolutionAltView />
          </div>
        </>
      )}
    </>
  );
};

export default HomePageView;
